/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Footer_Continue_PlusInputs */

const en_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const ar_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const de_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const es_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const fr_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const it_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const ja_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const ko_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const pt_br_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const ru_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const th_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const tr_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Plus Membership will be extended after purchase.
No auto-renewal after expiration.`)
};

const zh_cn_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买后 Plus 会员效期自动延长。到期后不会自动续费。`)
};

const zh_tw_subscription_footer_continue_plus = /** @type {(inputs: Subscription_Footer_Continue_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买后 Plus 会员效期自动延长。到期后不会自动续费。`)
};

/**
* | output |
* | --- |
* | "Your Plus Membership will be extended after purchase. No auto-renewal after expiration." |
*
* @param {Subscription_Footer_Continue_PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_footer_continue_plus = /** @type {((inputs?: Subscription_Footer_Continue_PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Footer_Continue_PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_footer_continue_plus(inputs)
	if (locale === "ar") return ar_subscription_footer_continue_plus(inputs)
	if (locale === "de") return de_subscription_footer_continue_plus(inputs)
	if (locale === "es") return es_subscription_footer_continue_plus(inputs)
	if (locale === "fr") return fr_subscription_footer_continue_plus(inputs)
	if (locale === "it") return it_subscription_footer_continue_plus(inputs)
	if (locale === "ja") return ja_subscription_footer_continue_plus(inputs)
	if (locale === "ko") return ko_subscription_footer_continue_plus(inputs)
	if (locale === "pt_br") return pt_br_subscription_footer_continue_plus(inputs)
	if (locale === "ru") return ru_subscription_footer_continue_plus(inputs)
	if (locale === "th") return th_subscription_footer_continue_plus(inputs)
	if (locale === "tr") return tr_subscription_footer_continue_plus(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_footer_continue_plus(inputs)
	return zh_tw_subscription_footer_continue_plus(inputs)
});